export enum PromptTemplateScope {
  Personal = 'personal',
  Organisation = 'organisation',
}

export const PROMPT_TEMPLATE_TITLE_MAX_LENGTH = 200;

/**
 * Shared character limit for Kim inputs — both the chat message input and the
 * body of a saved prompt template (templates are reusable Kim prompts).
 */
export const KIM_INPUT_CHARACTER_LIMIT = 5000;
